module.exports = __webpack_public_path__ + "img/szjw.497888d1.jpg";